export const MINT_CATEGORY_ID = 'mintCategoryId';
